import store from "@/store/index"
import _ from "lodash"
import { nanoid } from "nanoid"

import { mapState } from "vuex"
import { mapGetters } from "vuex/dist/vuex.common.js"
import { createAutoMsg } from "@/utils/chat/autoMsg"
import { getDayRecommand } from "@/api/home"
import { initQuestion } from "@/utils/question/QuestionInitializer"


var isCreateSession = false
export default {
    data() {
        return {
        }
    },
    computed: {
        ...mapState(["conversations", "robotId", "robots", "isMobile"]),
        ...mapGetters(["activeConversation"]),
        activeConversationId() {
            return this.$store.getters.activeConversation?.id;
        },

    },
    methods: {
        async newSessionClick(isWarn = false) {
            try {
                let session = this.activeConversation
                let noSession = !session || Object.keys(session).length === 0

                // 题库系统  没有会话，新建一个
                if (noSession) {
                    await this.newSession()
                    return
                }
                let sessionId = this.activeConversation.id
                let isExistNew = false
                const chatList = session.messages
                if (
                    (this.robotId === "exercises" || this.robotId === "mexercises") && chatList.length === 2 ||
                    this.robotId === "pexercises" && chatList.length === 1 ||
                    (this.robotId === "composition" && chatList.length === 1)
                  ) {
                    store.commit("setSessionId", sessionId)
                    this.$router.push(`/chatSearch/${this.robotId}/${sessionId.slice(-10)}`)
                    if (isWarn) {
                      this.$message.warning("已是最新会话")
                    }
                    isExistNew = true
                  }

                if (!isExistNew) {
                    await this.newSession()
                }
            } catch (error) {
                console.log(error)
            } finally {
                if (this.isMobile) {
                    store.commit("SET_FOLDHISTORY")
                }
            }

        },



        // 开启题库系统的新会话
        async newSession(name = "新会话") {
            if (isCreateSession) return
            isCreateSession = true
            let robot = this.robots[this.robotId]
            let res = await robot.startNewSession()
            isCreateSession = false
            if (!res.data || !res.data.sessionId) {
                this.$message.warning("开启新会话失败")
                return
            }
            let {
                data: { sessionId }
            } = res
            await this.$store.dispatch('createConversation', {
                aiType: this.robotId,
                id: sessionId,
                name,

            });
            store.commit("setSessionId", sessionId)
            this.$router.push(`/chatSearch/${robot.id}/${sessionId.slice(-10)}`)

            store.commit("SET_ROBOTSESSIONMAP", { robotId: robot.id, sessionId })
            this.startNewSession(robot.id, sessionId)
            if (robot.id !== "exercises" && robot.id !== "mexercises") return

            await this.getRecommandByDay(robot.id, sessionId)
        },
        async startNewSession(robotId, sessionId) {
            // store.commit("ADD_NEWCHAT", { robotId, sessionId })
            const msg = {
                type: "new", msg: "新会话", createTime: this.formatDate(new Date()),
                sessionId,
                robotId
            }

            // store.commit("UPDATE_MESSAGE", { robotId, key: sessionId, msg })
            await this.$store.dispatch('addMessageToConversation', {
                message: msg,
                type: "new"
            });

            this.$emit("handlScroll")
            this.lastAnswerContent = {}
        },

        //获取答题系统的回复
        async getRecommandByDay(robotId, sessionId) {
            let { data } = await getDayRecommand()
            if(!data) return
            let autoMsg = createAutoMsg(this.robots[robotId].avatar, this.$delete);
            console.log('=======autoMsg=====', autoMsg)
            autoMsg.base64 = data.base64;
            autoMsg.filename = data.filename;
            autoMsg.recommend = data.recommend;
            autoMsg.blockid = data.blockid;
            autoMsg.isDone = 1;
            autoMsg.controller = null;
            let part = {};
            autoMsg.msg = "";
            part.msg = data.content;
            part.title = data.title;
            let questions = data.questions;
            if (questions.length >= 1) {
                part.questions = initQuestion(questions);
            }
            autoMsg.parts.push(part);
            autoMsg.sessionId = sessionId;
            autoMsg.robotId = robotId;
            // 添加用户消息到对话
            await this.$store.dispatch('addMessageToConversation', {
                message: autoMsg,
            });


        },
        formatDate(date) {
            let year = date.getFullYear()
            let month = ("0" + (date.getMonth() + 1)).slice(-2)
            let day = ("0" + date.getDate()).slice(-2)
            let hour = ("0" + date.getHours()).slice(-2)
            let minute = ("0" + date.getMinutes()).slice(-2)
            let second = ("0" + date.getSeconds()).slice(-2)
            return (
                year +
                "-" +
                month +
                "-" +
                day +
                " " +
                hour +
                ":" +
                minute +
                ":" +
                second
            )
        },
    },

}